module.exports = __webpack_public_path__ + "img/编组 29@2x.f1a57d0e.png";